import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AuthGuard } from './shared/auth/auth-guard';
import { AccountInformationComponent } from './shared/components/account-information/account-information.component';
import { UserAdministrationComponent } from '@shared/components/user-administration/user-administration.component';
import { LabsComponent } from './components/labs/labs.component';
import { SearchComponent } from './components/well/search/search.component';
import { AddWellComponent } from './components/well/add/add-well.component';
import { EditWellComponent } from './components/well/edit/edit-well.component';
import { ReportsWellComponent } from './components/well/reports/reports-well.component';
import { AddSampleComponent } from './components/well/samples/add/add-samples.component';
import { DeleteSampleComponent } from './components/well/samples/delete/delete-samples.component';
import { EditSampleComponent } from './components/well/samples/edit/edit-samples.component';
import { ReportsVoucherComponent } from './components/vouchers/reports/reports-voucher.component';
import { MissingLatLongComponent } from './components/vouchers/reports/MissingLatLong/missing-lat-long.component';
import { HouseholdMultipleHousingUnitsComponent } from './components/households/reports/MultipleHousingUnits/household-multiple-housing-units.component';
import { VoucherExceedanceNotIndicatedReportComponent } from './components/vouchers/reports/VouchersWithExceedanceNotIndicatedReport/voucher-exceedance-not-indicated';
import { NitrateExceedanceReportComponent } from './components/vouchers/reports/lubgwma/NitrateExceedanceReport/nitrate-exceedance-report.component';
import { ImportVoucherApplicationsComponent } from './components/vouchers/import/import-voucher-applications';
import { UploadVoucherTestResultsComponent } from './components/vouchers/uploads/upload-voucher-test-results';
import { VoucherEditComponent } from './components/vouchers/edit/voucher-edit';
import { EditVoucherApplicationComponent } from './components/vouchers/edit/application-edit.component';
import { SearchVouchersComponent } from './components/vouchers/search/search-vouchers.component';
import { AddVoucherComponent } from './components/vouchers/add/add-voucher-application.component';
import { SearchHouseholdsComponent } from './components/households/search/search-households.component';
import { AddHouseholdComponent } from './components/households/add/add-household.component';
import { HouseholdEditComponent } from './components/households/edit/household-edit';
import { HousingUnitEditComponent } from './components/households/edit/units/housingunit-edit';
import { AddHousingUnitComponent } from './components/households/add/units/add-housingunit.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SearchInvoicesComponent } from './components/invoices/search/search-invoices.component';
import { InvoiceEditComponent } from './components/invoices/edit/invoice-edit';
import { AddInvoiceComponent } from './components/invoices/add/add-invoice.component';
import { RetestsSearchComponent } from './components/retests/search/retests-search.component';
import { ChainOfCustodyComponent } from './components/retests/chain-of-custody/chain-of-custody.component';
import { HouseholdMissingLatLongComponent } from './components/households/reports/MissingLatLong/household-missing-lat-long.component';
import { HouseholdInteractionsApprovalNeededReportComponent } from './components/households/interactions/householdInteractionsApprovalNeededReport/household-Interactions-approval-needed';
import { PartnerAdministrationComponent } from './components/admin/partners/partner-administration.component';
import { PartnerAccessComponent } from './components/partners/partner-access.component';
import { PartnersLubgwmaPlumbersComponent } from './components/partners/lubgwma-plumbers/lubgwma-plumbers.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },

      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'account-information', component: AccountInformationComponent, canActivate: [AuthGuard] },
      { path: 'welcome', component: WelcomeComponent },
      {
        path: 'sessions',
        loadChildren: () => import('./shared/components/sessions/sessions.module').then(m => m.SessionsModule)
      },
      {
        path: "user-management",
        component: UserAdministrationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "partner-management",
        component: PartnerAdministrationComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "Partner/Access/:id",
        component: PartnerAccessComponent
      },
      { path: 'labs', component: LabsComponent, canActivate: [AuthGuard] },
      { path: 'well', redirectTo: 'well/dashboard', pathMatch: 'full' },
      { path: 'well/search', component: SearchComponent, canActivate: [AuthGuard] },
      { path: 'well/add', component: AddWellComponent, canActivate: [AuthGuard] },
      { path: 'well/edit/:id', component: EditWellComponent, canActivate: [AuthGuard] },
      { path: 'well/reports', component: ReportsWellComponent, canActivate: [AuthGuard] },
      { path: 'well/samples/add', component: AddSampleComponent, canActivate: [AuthGuard] },
      { path: 'well/samples/delete/:id', component: DeleteSampleComponent, canActivate: [AuthGuard] },
      { path: 'well/samples/edit/:id', component: EditSampleComponent, canActivate: [AuthGuard] },
      { path: 'well/samples/edit/:id/:added', component: EditSampleComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/reports', component: ReportsVoucherComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/search', component: SearchVouchersComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/add', component: AddVoucherComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/application/edit/:id', component: EditVoucherApplicationComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/edit/:id', component: VoucherEditComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/upload', component: UploadVoucherTestResultsComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/import', component: ImportVoucherApplicationsComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/import/:type', component: ImportVoucherApplicationsComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/reports', component: ReportsVoucherComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/reports/nitrate-exceedance', component: NitrateExceedanceReportComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/reports/exceedance-not-indicated', component: VoucherExceedanceNotIndicatedReportComponent, canActivate: [AuthGuard] },
      { path: 'vouchers/reports/missing-lat-long', component: MissingLatLongComponent, canActivate: [AuthGuard] },
      { path: 'households/interactions/householdInteractionsApprovalNeededReport', component: HouseholdInteractionsApprovalNeededReportComponent, canActivate: [AuthGuard] },
      { path: 'household/reports/missing-lat-long', component: HouseholdMissingLatLongComponent, canActivate: [AuthGuard] },
      { path: 'household/reports/multiple-housing-units', component: HouseholdMultipleHousingUnitsComponent, canActivate: [AuthGuard] },
      { path: 'households/search', component: SearchHouseholdsComponent, canActivate: [AuthGuard] },
      { path: 'households/add', component: AddHouseholdComponent, canActivate: [AuthGuard] },
      { path: 'households/edit/:id', component: HouseholdEditComponent, canActivate: [AuthGuard] },
      { path: 'housingunit/add', component: AddHousingUnitComponent, canActivate: [AuthGuard] },
      { path: 'housingunit/edit/:id', component: HousingUnitEditComponent, canActivate: [AuthGuard] },
      { path: 'invoices/search', component: SearchInvoicesComponent, canActivate: [AuthGuard] },
      { path: 'invoices/edit/:id', component: InvoiceEditComponent, canActivate: [AuthGuard] },
      { path: 'invoices/add', component: AddInvoiceComponent, canActivate: [AuthGuard] },
      { path: 'retests/search', component: RetestsSearchComponent, canActivate: [AuthGuard] },
      { path: 'retests/chain-of-custody', component: ChainOfCustodyComponent, canActivate: [AuthGuard] }
    ],
  },
  { path: '**', redirectTo: 'training' },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      initialNavigation: !isIframe ? "enabledNonBlocking" : "disabled",
      relativeLinkResolution: 'legacy',
    })
  ],
  exports: [RouterModule],
  declarations: [
  ]
})
export class RoutesRoutingModule { }
